module.exports = __webpack_public_path__ + "img/darmin_plus_full.c06aec8a.svg";